import { render } from "./ManageAccountRules.vue?vue&type=template&id=a1fc1828&scoped=true"
import script from "./ManageAccountRules.vue?vue&type=script&lang=js"
export * from "./ManageAccountRules.vue?vue&type=script&lang=js"

import "./ManageAccountRules.vue?vue&type=style&index=0&id=a1fc1828&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1fc1828"]])

export default __exports__